import React, { createContext, useContext } from 'react';

interface WebViewContextType {
  isWebView: boolean;
  pathPrefix: string;
}

const WebViewContext = createContext<WebViewContextType>({
  isWebView: false,
  pathPrefix: '',
});

export const useWebView = () => useContext(WebViewContext);

export const prefixPath = (path: string, prefix: string): string => {
  if (!prefix || !path) return path || '';
  // Don't prefix external URLs, anchors, or already-prefixed paths
  if (path.startsWith('http') || path.startsWith('#') || path.startsWith(prefix)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${prefix}${normalizedPath}`;
};

export default WebViewContext;
